import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import withStyles from '@material-ui/core/styles/withStyles'
import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import TagsManagementForm from '../TagsManagementForm'
import { TAGS_MANAGEMENT_FORM_MODES } from '../const'
import { createTag } from './gql'
import { styles } from './styles'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

const BreadcrumbsCreateTag = () => {
  return (
    <StyledBreadcrumbs
      icon={<SettingsIcon style={{ width: 20 }} />}
      breadcrumbs={[
        {
          label: 'Settings',
          link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        },
        {
          label: 'Tags Management',
          link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagement
          }`,
        },
        { label: 'Create' },
      ]}
    />
  )
}

const TagsManagementCreate = ({ classes }) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const navigateBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.tagsManagement
      }`,
    )
  }

  const handleCrateSubmit = async (form, isValid) => {
    if (isValid) {
      setLoading(true)
      const { name, type } = form
      try {
        await createTag({
          value: name.value,
          type: type.value,
        })
        navigateBack()
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <div className={classes.wrapper}>
      <BreadcrumbsCreateTag />
      <TagsManagementForm
        mode={TAGS_MANAGEMENT_FORM_MODES.CREATE}
        handleCancel={navigateBack}
        buttonsDisabled={loading}
        handleSubmit={handleCrateSubmit}
      />
    </div>
  )
}

export default withStyles(styles)(TagsManagementCreate)
